import { ErrorDto } from './error-dto';
import { responseMessage } from './message-error';

export class ConflictError extends Error {
  error: string;

  statusCode: number;

  code?: string;

  data?: unknown;

  constructor(body: ErrorDto) {
    super(responseMessage(body.message));
    this.name = 'ConflictError';
    this.error = body.error;
    this.message = responseMessage(body.message);
    this.statusCode = body.statusCode || 409;
    this.code = body.code;
    this.data = body.data;
  }
}
